<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div
      @click="select('creditcard')"
      class="border-2 rounded-lg p-4 cursor-pointer transition-colors hover:border-mifo-accent"
      :class="[
        modelValue === 'creditcard' ? 'border-mifo-accent bg-mifo-accent/5' : 'border-gray-300'
      ]"
    >
      <div class="flex items-center space-x-3">
        <img src="/payment-icons/credit-card.svg" alt="Credit Card" class="w-8 h-8" />
        <div>
          <h3 class="font-medium text-gray-900">Kreditkarte</h3>
          <p class="text-sm text-gray-500">Visa, Mastercard, etc.</p>
        </div>
      </div>
    </div>

    <div
      @click="select('paypal')"
      class="border-2 rounded-lg p-4 cursor-pointer transition-colors hover:border-mifo-accent"
      :class="[
        modelValue === 'paypal' ? 'border-mifo-accent bg-mifo-accent/5' : 'border-gray-300'
      ]"
    >
      <div class="flex items-center space-x-3">
        <img src="/payment-icons/paypal.svg" alt="PayPal" class="w-8 h-8" />
        <div>
          <h3 class="font-medium text-gray-900">PayPal</h3>
          <p class="text-sm text-gray-500">Schnell und sicher</p>
        </div>
      </div>
    </div>

    <div
      @click="select('paybybank')"
      class="border-2 rounded-lg p-4 cursor-pointer transition-colors hover:border-mifo-accent"
      :class="[
        modelValue === 'paybybank' ? 'border-mifo-accent bg-mifo-accent/5' : 'border-gray-300'
      ]"
    >
      <div class="flex items-center space-x-3">
        <img src="/payment-icons/pay-by-bank.svg" alt="Pay by Bank" class="w-8 h-8" />
        <div>
          <h3 class="font-medium text-gray-900">Pay by Bank</h3>
          <p class="text-sm text-gray-500">Direkte Bankverbindung</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethodSelector',
  props: {
    modelValue: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const select = (value) => emit('update:modelValue', value)
    return { select }
  }
}
</script>

